import VueI18n from '@/i18n/locale';
import env from './utils/env';
import { filterCity } from './utils';
import { API } from './services';
// 按钮状态
export const CURRENT_STATUS = {
  PENDING: 1, // 待处理
  PROCCESSING: 2, // 处理中
  DONE: 3, // 已完成
};

// 紧急程度映射
export const ERGENCY_LEVEL = {
  1: VueI18n.t('Gattaran_Feedback__urHD' /** 低 */),
  2: VueI18n.t('Gattaran_Feedback__fRJi' /** 中 */),
  3: VueI18n.t('Gattaran_Feedback__amKQ' /** 高 */),
};

export const createSendFormSchema = (that) => {
  const prefixUrl = env.get('config').prefixUrl;
  const getAuthParams = env.get('config').getAuthParams;
  const timezone = env.get('options').timezone;
  return {
    type: 'object',
    properties: {
      layout: {
        type: 'void',
        'x-component': 'FormLayout',
        'x-component-props': {
          layout: 'vertical',
        },
        properties: {
          module: {
            title: VueI18n.t('Gattaran_Feedback__QLll' /** 问题发生的Gattaran功能模块 */),
            required: true,
            'x-decorator': 'FormItem',
            'x-component': 'Cascader',
            'x-reactions': ['{{useAsyncDataSource(doGetModule)}}'],
            'x-component-props': {
              placeholder: VueI18n.t('Gattaran_Feedback__vYiO' /** 请选择 */),
            },
          },
          level: {
            title: VueI18n.t('Gattaran_Feedback__MQam' /** 紧急程度 */),
            required: true,
            'x-decorator': 'FormItem',
            'x-component': 'Radio.Group',
            enum: [
              {
                label: VueI18n.t('Gattaran_Feedback__dOJj' /** 低 */),
                value: 1,
              },
              {
                label: VueI18n.t('Gattaran_Feedback__cLbb' /** 中 */),
                value: 2,
              },
              {
                label: VueI18n.t('Gattaran_Feedback__Xbej' /** 高 */),
                value: 3,
              },
            ],
            default: 1,
          },
          area: {
            title: VueI18n.t('Gattaran_Feedback__Govn' /** 问题发生的区域 */),
            required: true,
            'x-decorator': 'FormItem',
            'x-component': 'Cascader',
            'x-reactions': ['{{useAsyncDataSource(doGetArea)}}'],
            'x-component-props': {
              placeholder: VueI18n.t('Gattaran_Feedback__vYiO' /** 请选择 */),
              clearable: true,
              props: {
                lazy: true,
                multiple: true,
                checkStrictly: true,
                lazyLoad: (node, resolve) => {
                  const { value, level } = node;
                  // 只有第一层级需要懒加载
                  if (level > 1) return resolve();
                  API()
                    .getArea({
                      country: value || env.get('options').country,
                      sortType: 'nameSort',
                      timezone,
                      returnData: 'regionCity',
                    })
                    .then((res) => {
                      const nodes = res.map(({ regionName: value, regionName: label, cities = [] }) => {
                        return {
                          label,
                          value,
                          children: filterCity(cities),
                        };
                      });
                      resolve(nodes);
                    });
                },
              },
            },
          },
          link: {
            title: VueI18n.t('Gattaran_Feedback__zzVL' /** 问题发生的页面链接 */),
            required: true,
            'x-decorator': 'FormItem',
            'x-component': 'Input',
            'x-component-props': {
              placeholder: VueI18n.t('Gattaran_Feedback__xywA' /** 请输入 */),
              clearable: true,
            },
          },
          description: {
            title: VueI18n.t('Gattaran_Feedback__bpPs' /** 问题描述 */),
            required: true,
            'x-decorator': 'FormItem',
            'x-component': 'Input.TextArea',
            'x-component-props': {
              placeholder: VueI18n.t('Gattaran_Feedback__chUi' /** 请输入问题的详细描述，比如When、How to do、What、How often等 */),
              rows: 5,
              showWordLimit: true,
              maxlength: 500,
            },
          },
          picture: {
            title: VueI18n.t('Gattaran_Feedback__zEDP' /** 图片附件（最多5张，每张不超过5M） */),
            type: 'array',
            required: true,
            'x-decorator': 'FormItem',
            'x-component': 'Upload',
            'x-component-props': {
              action: prefixUrl('common.uploadPublicPic'),
              multiple: true,
              listType: 'picture-card',
              headers: getAuthParams(),
              accept: '.png, .jpg, .svg',
              name: 'upfile',
              limit: 5,
              // 超过五张图片给提示
              onExceed: () => {
                that.$message.warning(VueI18n.t('Gattaran_Feedback__ykZG' /** 最多上传5张图片 */));
              },
              beforeUpload: (file) => {
                // file.size 是Bytes, 1KB = 1024Bytes, 1M = 1024KB
                const isLt5M = file.size / 1024 / 1024 <= 5;
                if (!isLt5M) {
                  that.$message.warning(VueI18n.t('Gattaran_Feedback__zEDP' /** 图片附件（最多5张，每张不超过5M） */));
                  return false;
                }
              },
              fileList: [],
              'on-success': (res, file) => {
                file.link = res.data;
              },
            },
          },
          attachment: {
            type: 'array',
            title: VueI18n.t('Gattaran_Feedback__IdvX' /** 其它附件（excel、pdf、word，限1个） */),
            'x-decorator': 'FormItem',
            'x-component': 'Upload',
            'x-component-props': {
              action: prefixUrl('common.uploadPublicPic'),
              textContent: VueI18n.t('Gattaran_Feedback__mVws' /** 上传 */),
              accept: '.pdf, .docx, .xlsx, .pptx',
              listType: 'fileList',
              headers: getAuthParams(),
              // 指定上传的文件字段名
              name: 'upfile',
              limit: 1,
              // 超过一张图片给提示
              onExceed: () => {
                that.$message.warning(VueI18n.t('Gattaran_Feedback__gRVu' /** 最多只能上传1个非图片类型的附件 */));
              },
              fileList: [],
              onSuccess: (res, file) => {
                file.link = res.data;
              },
            },
          },
        },
      },
    },
  };
};
